<template>
    <div class="row article-slider" :class="className">
        <div class="col-12" :id="id + '-slider'" :class="id + '-content'">
            <div v-if="items && items.length > 0">
                <VueSlickCarousel ref="slick" v-bind="slickSettings" class="article-slider-content">
                    <a v-for="item in items" :href="item.href" class="featured-el news">
                        <div class="hover-effect"></div>
                        <div class="image" :class="{ 'no-image': !item.image_url || item.image_url === 0 }">
                            <picture v-if="item.image_url && item.image_url.length > 0">
                                <img v-lazy="item.image_url" :alt="item.title" loading="lazy" />
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden"></span>
                                </div>
                            </picture>
                            <div
                                class="tag"
                                v-if="displayTags"
                                :class="'tag-with-color ' + item.type"
                                v-text="item.typename"
                            ></div>
                        </div>
                        <div class="title" v-text="item.title"></div>
                        <div class="desc" v-text="item.lead"></div>
                        <div class="btn readmore">{{ labelReadMore }}</div>
                    </a>
                </VueSlickCarousel>
            </div>
        </div>
    </div>
</template>

<script>
//TODO: show/hide dots with prop
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    components: { VueSlickCarousel },
    props: ["id", "items", "className", "labelReadMore", "displayTags", "perPage"],

    watch: {
        items: function () {
            this.$nextTick(() => {
                if (!this.$refs.slick) return;
                this.$refs.slick.$emit("reInit");
            });
        },
    },

    data: () => {
        return {
            currentFilter: "",
            slickSettings: {
                arrows: true,
                adaptiveHeight: false,
                draggable: true,
                dots: false,
                infinite: true,
                speed: 300,
                variableWidth: false,
                slidesToShow: 5,
            },
        };
    },

    mounted() {
        let sliderElement = document.getElementById(this.id + "-slider");
        let maxSlidesToShow = 5;

        if (this.perPage === undefined || this.perPage === "") {
            maxSlidesToShow = Math.round(sliderElement.clientWidth / 284);
        } else {
            maxSlidesToShow = parseInt(this.perPage);
        }

        this.slickSettings.slidesToShow = maxSlidesToShow;

        if (this.id !== "featured") return;

        this.slickSettings.responsive = [
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: maxSlidesToShow,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: maxSlidesToShow - 1,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: maxSlidesToShow - 2,
                },
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: maxSlidesToShow - 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ];
    },
};
</script>
